/**
 * What an interest's status is called, and what colour it is, everywhere.
 *
 * One file for the list and the detail screen, for `tenant-status.ts`'s reason:
 * two screens that disagree about what a status is called are two screens a
 * sales team stops trusting.
 *
 * `new` is the warm tone on purpose — it is the one that needs somebody to act.
 * `closed` is neutral rather than good: closed means the conversation ended,
 * and nothing here records whether it ended in a sale.
 */
import type { InterestFilter, InterestSource, InterestStatus } from '@wend/shared';
import type { BadgeTone } from '@wend/ui';

export const INTEREST_STATUS_LABEL: Readonly<Record<InterestStatus, string>> = {
  new: 'New',
  in_progress: 'In progress',
  closed: 'Closed',
};

export const INTEREST_STATUS_TONE: Readonly<Record<InterestStatus, BadgeTone>> = {
  new: 'warn',
  in_progress: 'info',
  closed: 'neutral',
};

export const INTEREST_SOURCE_LABEL: Readonly<Record<InterestSource, string>> = {
  site: 'Website form',
  admin: 'Added by staff',
};

export const INTEREST_FILTER_LABEL: Readonly<Record<InterestFilter, string>> = {
  open: 'Open',
  new: 'New',
  in_progress: 'In progress',
  closed: 'Closed',
  all: 'All',
};
